import React from 'react';
import { useSelector } from 'react-redux';
import { Monitoring as MonitoringComp } from '@axtria/hqi-configurator';
const baseURL = process.env.REACT_APP_HQI_BASE_URL
const middlewareURL = process.env.REACT_APP_HQI_MIDDLEWARE_URL
const UMUrl = process.env.REACT_API_URL

interface MonitoringProps {
  mainView?: 'overview' | 'logs';
}

const Monitoring: React.FC<MonitoringProps> = ({ mainView = 'logs' }) => {
  const { userInfo, apiVersionName } = useSelector((state: any) => ({
    userInfo: state.loginResource,
    apiVersionName: state.loginResource.apiVersionName ?? 'V1',
  }));
  const getPreferredProjectName = (data: any) => {
    const company = data.company_data.find((c: any) => c.companyId === data.preferredCompany);
    if (!company) return null;

    const project = company.projectList.find((p: any) => p.project_id === data.preferredProject);
    return project ? project.project_name : null;
  };
  return (
    <>
      {userInfo?.preferredProject && (
        <MonitoringComp
          key={`${userInfo?.preferredProject}-${mainView}`}
          DOMAIN={baseURL}
          DOMAIN_MIDDLEWARE={middlewareURL}
          USER_ID={65}
          PROJECT_ID={userInfo?.preferredProject}
          PROJECT_NAME={getPreferredProjectName(userInfo)}
          KNOWLEDGE_ID={userInfo?.activeKnowledgeId}
          DOMAIN_UM={UMUrl}
          mainView={mainView}
          config={{ showAIAnalysisFlag: true, UI_Enhancement: apiVersionName === 'V1' }}
        />
      )}
    </>
  );
};

export default Monitoring;
